import request from 'utils/request'
import { MCASS020CreateRequest } from 'types/MCASS020/MCASS020CreateRequest'

export const sendRequest = (data: MCASS020CreateRequest) =>
    request({
        url: `MCASS020/send`,
        method: 'post',
        data: data,
    })
